module.exports = __webpack_public_path__ + "static/icons/icon-skiresortsi-1f220256d42a4a0fa2cff79d79b87a45.svg";